var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "var(--color-tertiary)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#yellowPLus)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.902 8.93H10.09v-3.8a.19.19 0 00-.191-.19h-.763a.19.19 0 00-.19.19v3.8H5.13a.19.19 0 00-.191.19v.76c0 .105.085.19.19.19h3.814v3.8c0 .105.086.19.191.19h.763a.19.19 0 00.19-.19v-3.8h3.814a.19.19 0 00.191-.19v-.76a.19.19 0 00-.19-.19z",
    fill: "var(--color-tertiary-fg)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "yellowPLus"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4.94 4.94)",
    d: "M0 0h9.12v9.12H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowPlus);
export default __webpack_public_path__ + "static/media/yellow-plus.e88be7b39d858886b3f693bfbda75129.svg";
export { ForwardRef as ReactComponent };